import { createRoute } from "@tanstack/react-router";
import {
  RouteErrorComponent,
  RoutePendingFallback,
} from "@/app/router/components/RouteBoundaries";
import { CollectionsOverview } from "@/features/collections";
import { rootRoute } from "@/routes/root";

export const collectionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/collections",
  component: CollectionsOverview,
  pendingComponent: RoutePendingFallback,
  errorComponent: RouteErrorComponent,
});
